module.exports = __webpack_public_path__ + "5fd22b4ba47baba22f32722049414b8c.svg";